<template>
	<div class="xiangmu">
<!--		<breadcrumb :routerList="[{to:'/agent/agentCopy',title:'经销商管理'},{title:'供应商列表'}]"/>-->
    <Breadtabsheader/>
		<div class="h-piece h-mrt30">
			<div class="h-formBox hidden">
				<el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
					<div class="h-thirdColumn w-newColumn">
						<el-form-item label="　供应商姓名">
							<el-input v-model="formInline.userName" placeholder="请输入" :clearable="true"></el-input>
						</el-form-item>
						<el-form-item label="　供应商状态">
							<el-select v-model="formInline.status" :clearable="true">
								<el-option label="禁用/冻结" value="0"></el-option>
								<el-option label="正常" value="1"></el-option>
								<el-option label="申诉中" value="3"></el-option>
								<el-option label="审批中" value="4"></el-option>
								<el-option label="驳回" value="5"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="　　审批开始时间">
							<el-date-picker
								style="width: 100%;"
								v-model="formInline.startCdate"
								type="date"
								value-format="yyyy-MM-dd"
								placeholder="开始日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="　　审批结束时间">
							<el-date-picker
								style="width: 100%;"
								v-model="formInline.endCdate"
								type="date"
								value-format="yyyy-MM-dd"
								placeholder="结束日期">
							</el-date-picker>
						</el-form-item>
					</div>
					<el-collapse-transition>
						<div v-show="isScreen">
							<div class="h-thirdColumn w-newColumn">
								<el-form-item label="　　到期开始时间">
									<el-date-picker
										style="width: 100%;"
										v-model="formInline.startAccountdate"
										type="date"
										value-format="yyyy-MM-dd"
										placeholder="开始日期">
									</el-date-picker>
								</el-form-item>
								<el-form-item label="　　到期结束时间">
									<el-date-picker
										style="width: 100%;"
										v-model="formInline.endAccountdate"
										type="date"
										value-format="yyyy-MM-dd"
										placeholder="结束日期">
									</el-date-picker>
								</el-form-item>
							</div>
						</div>
					</el-collapse-transition>
				</el-form>
				<div class="l-screenBox">
					<div class="l-screen" @click="collapseChange">
						<img :src="isScreen?closeScreen:drawScreen" alt="">
						<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
					</div>
					<div class="l-retrieval">
						<el-button class="h-btn h-formBtn" @click="checkData('check')">检索</el-button>
						<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
					</div>
				</div>
			</div>
		</div>
		<div class="h-table h-mrt30" v-if="clickActive==1">
			<el-table
			
					@selection-change="handleSelectionChange"
					:data="supplierList"
					border
					style="width: 100%"
					max-height="430"
			>
				<el-table-column
						type="selection"
						width="40"
						:label="all">
				</el-table-column>
				<el-table-column
						type="index"
						width="40"
						label="#">
				</el-table-column>
				<el-table-column
						prop="userName"
						label="供应商姓名"
						min-width="250"
						:show-overflow-tooltip="true"
						>
						<template slot-scope="scope">
							<div style="text-align: left;">
								{{scope.row.userName}}
							</div>
						</template>
				</el-table-column>
				<el-table-column
						prop="usercode"
						label="供应商编码"
						:show-overflow-tooltip="true"
						width="150">
				</el-table-column>
				<el-table-column
						prop="companyIdCode"
						label="纳税人登记号"
						:show-overflow-tooltip="true"
						width="180">
						<template slot-scope="scope">
							<div style="text-align: left;">
								{{scope.row.companyIdCode}}
							</div>
						</template>
				</el-table-column>
				<el-table-column
						prop="type"
						label="供应商分类"
						:show-overflow-tooltip="true"
						width="150">
					<template slot-scope="scope">
						<dictname category="supplier_type" :v="scope.row.type"/>
					</template>
				</el-table-column>
				<el-table-column
						prop="status"
						label="供应商状态"
						:show-overflow-tooltip="true"
						width="150">
					<template slot-scope="scope">
						<dictname category="zhuangtai_type" :v="scope.row.status"/>
					</template>
				</el-table-column>
				<el-table-column
						prop="cdate"
						label="审批时间"
						:show-overflow-tooltip="true"
						width="100">
				</el-table-column>
				<el-table-column
						prop="accountdate"
						label="到期时间"
						:show-overflow-tooltip="true"
						width="100">
				</el-table-column>

				<el-table-column label="操作" width="200" fixed="right">
					<template slot-scope="scope">
						<div class="w-caozuo" style="text-align: left;">
							<el-button
									type="text"
									size="small"
									@click="checkDetail(scope.row)"
									class="h-tableLink h-btn">
								查看
							</el-button>
							<el-button
									type="text"
									size="small"
									class="h-tableLink h-btn"
									@click="freeze(scope.row)">
								冻结
							</el-button>
							<el-button size="small" class="h-tableLink h-btn" type="text" @click="postpone(scope.row)">延期</el-button>
							<el-button size="small" class="h-tableLink h-btn" type="text" @click="unfreeze(scope.row)">解冻</el-button>
						</div>
						<!-- <div class="l-operationBox">
							<span class="l-operationlist br-operation-look" title="查看" @click="checkDetail(scope.row)"></span>
							<span class="l-operationlist br-operation-dj" title="冻结" @click="freeze(scope.row)"></span>
							<span class="l-operationlist br-operation-yq" title="延期" @click="postpone(scope.row)"></span>
							<span class="l-operationlist br-operation-jd" title="解冻" @click="unfreeze(scope.row)"></span>
						</div> -->
					</template>
				</el-table-column>
			</el-table>
			<!-- 延期 -->
			<el-dialog :close-on-click-modal="false" :visible.sync="centerDialogVisible1" class="h-dialog2">
				<div class="h-dialogImg">
					<div class="h-disTable">
						<div class="h-tableCell">
							<h1>延期</h1>
							<p>PostPone</p>
						</div>
					</div>
				</div>
				<div class="h-formLine " style="margin: 0.38rem 0 0 0;">
					<el-form :inline="true" :model="freezeData" class="demo-form-inline h-formBorder" style="margin-top: 0.4rem">
						<el-form-item label="到期日调整" style="margin-left:2rem;">
								<el-date-picker type="date" placeholder="选择时间" v-model="freezeData.timeData" ></el-date-picker>
						</el-form-item>
					</el-form>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button class="h-btn h-formBtn h-bgwhite" @click="centerDialogVisible = false">取 消</el-button>
					<el-button class="h-btn h-formBtn" @click="checkPostpone">确 定</el-button>
				</div>
			</el-dialog>
			<!-- 解冻 -->
			<el-dialog :close-on-click-modal="false" :visible.sync="centerDialogVisible" class="h-dialog2">
				<div class="h-dialogImg">
					<div class="h-disTable">
						<div class="h-tableCell">
							<h1>解冻</h1>
							<p>Unfreeze</p>
						</div>
					</div>
				</div>
				<div class="h-formLine h-mrb-38" style="margin: 0.38rem 0 0 0;">
					<el-form :inline="true" :model="freezeData" class="demo-form-inline h-formBorder" style="margin-top: 0.4rem">
						<el-form-item label="到期日调整" style="margin-left:2rem;">
								<el-date-picker type="date" placeholder="选择时间" v-model="freezeData.timeData" ></el-date-picker>
						</el-form-item>
					</el-form>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button class="h-btn h-formBtn h-bgwhite" @click="centerDialogVisible = false">取 消</el-button>
					<el-button class="h-btn h-formBtn" type="primary" @click="checkUnFreeze">确 定</el-button>
				</div>
			</el-dialog>
			<div class="left">
<!--				<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"-->
<!--						   @click="exportExcel">批量导出-->
<!--				</el-button>-->
<!--				<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"-->
<!--						   @click="daoru">批量导入-->
<!--				</el-button>-->
			</div>
			<div class="h-pagination2">
				<pagination :page="q" @query="choose"/>
			</div>
		</div>
		<!-- <el-dialog :visible.sync="dialogFormVisible2" width="53%" class="h-dialog3 dialogFormVisible3">
			<div class="h-dialogImg">
				<div style="display:flex;align-items:center;">
					<img src="../../assets/images/daoru-j.png" alt="" style="width: 86px;height: 86px;">
					<div>
                        <p class="piliang1">批量导入</p>
                        <p class="piliang2">导入文件请先下载模版并按照模版填写完成后，点击上传文件，上传文件不大于200M</p>
					</div>
				</div>
				<div class="piliangBox">
					<div class="imgs"><img src="../../assets/images/daoru-exls.png" alt=""
													style="width: 40px;height: 39px;"></div>
					<div class="imgs">批量导入模版文件.xlsx</div>
					<div class="imgs" style="color: #0865c4;cursor:pointer;">下载</div>
				</div>
				<div style="width:100%;">
					<el-upload
                        action="https://jsonplaceholder.typicode.com/posts/"
                        list-type="picture-card"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove"
                        style="width:100%;">
                        <div style="width:100%;">+ 上传文件</div>
					</el-upload>
				</div>
				<div style="display:flex;justify-content:center;margin-top:30px;">
					<el-button class="h-btn h-formBtn h-bgwhite" type="primary" @click="dialogFormVisible2 = false">
							取消
					</el-button>
					<el-button class="h-btn h-formBtn" type="primary" style="margin-left:40px;"
									@click="dialogFormVisible2 = false">提交
					</el-button>
				</div>
			</div>
		</el-dialog> -->
			</div>

</template>
<script>
	import supplierListService from "../../api/personal/supplierListService";
	import agentCopyService from "../../api/loud/agent/agentCopyService";
	import util from "../../utils/util";
	export default {
		data(){
			return{
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
				value2:'',
				value3:'',
				dialogFormVisible2:false,
				updateEndTime: {
					customerCode: null,
					contractEndtime: null
				},
				freezeData: {
					timeData: null,
					allData: null
				},
				updateData:{
					usercode: null,
					status: null
				},
				supplierList: [],
				centerDialogVisible: false,
				centerDialogVisible1: false,
				//表单
				dataList:[
					{  name: "哈哈" },
					{  name: "呵呵" },
					{  name: "晓丽" },
					{  name: "小兰" },
					{  name: "财务" },
					{  name: "嘻嘻" },
					{  name: "测试" }],
				list:[],
				input_value:"",
				state:false,

				all:'全部',
				formInline:{
					userName: null,
					status: null,
					startCdate: null,
					endCdate: null,
					startAccountdate:null,
					endAccountdate: null,
					pageSize:10,
					pageNo:1,
				},
				//表格
				multipleSelection: [],

				clickActive:1,
				q: {
					pageSize:10,
					pageNo:1,
					total:0
				},
				data:{
					index: null
				},
				isCheck: null
			}
		},
		created(){
			//查询供应商列表
			this.query();
		},
		methods:{
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
			timeSelect(){
				this.formInline.startCdate = this.value2[0];
				this.formInline.endCdate = this.value2[1];
			},
			timeSelect1(){
				this.formInline.startAccountdate = this.value3[0];
				this.formInline.endAccountdate = this.value3[1];
			},
			daoru() {
				this.dialogFormVisible2 = true;
			},
			// 延期按钮确认
			checkPostpone(){
				if(this.freezeData.timeData){
					//更新到期时间
					this.updateEndTime.customerCode = this.freezeData.allData.usercodeInfo;
					this.updateEndTime.contractEndtime = util.riQi3(this.freezeData.timeData);
					console.log(this.updateEndTime,'aaaaaaaaaa')
					agentCopyService.updateEndTime(this.updateEndTime).then(res=>{
						if(res.f){
							this.$message({
								type: 'success',
								message: '延期成功!'
							});
							this.query();
						}else{
							this.$msg.msge(res.msg)
						}
					});
					this.centerDialogVisible1 = false;
				}
				this.centerDialogVisible1 = false;
			},
			//解冻确认按钮
			checkUnFreeze(){
				if(this.freezeData.timeData){
					//更新经销商状态
					this.updateData.usercode = this.freezeData.allData.usercode;
					this.updateData.status = "1";
					agentCopyService.update(this.updateData);
					//更新到期时间
					this.updateEndTime.customerCode = this.freezeData.allData.usercode;
					this.updateEndTime.contractEndtime = util.riQi3(this.freezeData.timeData);
					console.log(this.updateEndTime,'aaaaaaaaaa')
					agentCopyService.updateEndTime(this.updateEndTime).then(res=>{
						if(res.f){
							this.$message({
								type: 'success',
								message: '解冻成功!'
							});
							this.query();
						}else{
							this.$msg.msge(res.msg)
						}
						
					});;
					this.centerDialogVisible = false;
				}
				this.centerDialogVisible = false;
				
			},
			//冻结按钮功能
			freeze(v){
				console.log(v,'v')
				if (v.status!=="0"){
					this.$confirm('此操作将冻结该经销商, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.updateData.usercode = v.usercode;
						this.updateData.status = "0";
						agentCopyService.update(this.updateData).then(res=>{
							if(res.f){
								this.$message({
								    type: 'success',
								    message: '冻结成功!'
								});
								this.query();
							}else{
								this.$msg.msge(res.msg)
							}
							
						});
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消冻结'
						});
					});
				}else{
					this.$message({
						type: 'error',
						message: '该经销商已被冻结!请勿重复操作'
					});
				}

			},
			//点击分页调用方法判断
			choose(){
				if (this.isCheck){
					this.checkData();
				}else{
					this.query();
				}
			},
			//重置按钮功能
			resetData(){
				this.value2 = '';
				this.value3 = '';
				this.formInline.userName = null;
				this.formInline.status = null;
				this.formInline.startCdate = null;
				this.formInline.endCdate = null;
				this.formInline.startAccountdate = null;
				this.formInline.endAccountdate = null;
				this.formInline.pageSize = 10;
				this.formInline.pageNo = 1;
			},
			//检索按钮功能
			checkData(v){
				this.isCheck = true;
				if (v ==='check'){
					this.formInline.pageNo = 1;
					this.formInline.pageSize = 10;
				}else{
					this.formInline.pageNo = this.q.pageNo;
					this.formInline.pageSize = this.q.pageSize;
				}
				if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.formInline.startCdate))){
					if (this.formInline.startCdate!==null) {
						this.formInline.startCdate = util.riQi3(this.formInline.startCdate);
					}
				}
				if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.formInline.endCdate))){
					if (this.formInline.endCdate!==null){
						this.formInline.endCdate = util.riQi3(this.formInline.endCdate);
					}
				}
				if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.formInline.startAccountdate))){
					if (this.formInline.startAccountdate!==null) {
						this.formInline.startAccountdate = util.riQi3(this.formInline.startAccountdate);
					}
				}
				if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.formInline.endAccountdate))){
					if (this.formInline.endAccountdate!==null){
						this.formInline.endAccountdate = util.riQi3(this.formInline.endAccountdate);
					}
				}
				console.log(this.formInline,'forminline')
				supplierListService.checkShangHai(this.formInline).then(response => {
					console.log(response,'response')
					this.supplierList = response.records;
					this.q.total = response.total;
				})
			},
			//审批按钮功能
			approve(v){
				this.data = v;
				this.data.index = '3';
				this.$router.push({path: '/agentDetail',query: this.data});
			},
			//查看按钮功能
			checkDetail(v){
				console.log(v);
				this.$router.push({path: '/personal/angentDetail',query: {usercode:v.usercode}});
			},
			//延期按钮功能
			postpone(v){
				this.centerDialogVisible1 = true;
				this.freezeData.allData = v;
			},
			//解冻按钮功能
			unfreeze(v){
				if (v.status==="0"){
					this.centerDialogVisible = true;
					this.freezeData.allData = v;
				}else{
					this.$message({
						type: 'error',
						message: '该经销商没有被冻结!无需解冻'
					});
				}

			},
			//转到新增页面
			toSign(v){
				this.$router.push({path: '/personal/signSupplier',query: {type:v}});
			},
			//查询当前登录用户对应区域的经销商列表
			query(){
				supplierListService.queryshanghai(this.q).then(response => {
					console.log(response,'response')
					this.q.total = response.total;
					this.supplierList = response.records;
				})
			},
			//表格
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			dianji(){
				if(item){
					this.input_value = v.name;

					this.state = false
				}
			},
			throttle(){
				console.log(this.input_value)
				this.dataList.forEach(v=>{
					if(this.input_value == v.name){
						this.state=true;

					}
				})
				// this.dianji()

			},
			// 延期弹窗
			createdemand(){
				this.dialogFormVisible1 = true;
			}
		},
		mounted(){
			
		},
	}
</script>
<style scoped>
	.left{
		margin-top: 20px;
	}
	.xuqiuBoxList .xuqiulist{
		width: 200px;
		height: 62px;
		border-radius: 4px;
		background: #fff;
		border: 1px solid #959595;
		text-align: center;
		line-height: 62px;
		color: #989898;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-left: 10px;
	}
	.xuqiuBoxList .xuqiulist:first-child{
		margin-left: 0
	}
	.xuqiuBoxList .xuqiulist.active{
		background: #238cfd;
		border: 1px solid #238cfd;
		color: #fff;
	}
	.xuqiutext{
		color: #bcbcbc;
		font-size: 14px;
		margin-bottom: 14px;
	}
	.xuqiuBoxList{
		width: 100%;
		margin-top: 30px;
		display: flex;
		justify-content: space-between;
	}
	.ul{
		position: absolute;
		background: #fff;
		padding: 5px 10px 5px 10px;
		z-index: 9;
		height: 100px;
		overflow-y: auto;
		text-align: center
	}
	.ul li:hover{
		background: #ccc;
		cursor: pointer;
	}
	.ul::-webkit-scrollbar{
		width: 0;
		display: none;
	}
	.xiangmu .h-piece, .h-mrt30{
		margin: 20px;
	}
	/* .h-formBtnOut  .h-mr20{
		margin-left:0.3rem !important;
	} */

</style>
<style>
	/* .h-formBox.hidden .h-formBorder .el-input__inner{
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	} */
	.cell .h-dialog2 .el-dialog{
		box-shadow: none;
	}
	.h-dialog3.dialogFormVisible3 .el-dialog__body {
		padding: 0 0.5rem 0.3rem 0.5rem;
	}
	.h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
		width: 100%;
		height: 103px;
		border: 1px dashed #7c9ec0;
		background: 0;
		line-height: 103px;
		margin-top: 20px;
		color: #4b4b4b;
		font-size: 18px;
	}
	.piliang1 {
		font-size: 18px;
		color: #303030;
		margin-top: 10px;
		margin-left: 10px;
	}
	.piliang2 {
		font-size: 16px;
		color: #919191;
		margin-top: 10px;
		margin-left: 10px;
	}
	.piliangBox {
		display: flex;
		margin-top: 20px;
		align-items: center;

		margin-bottom: 20px;
	}
	.piliangBox .imgs {
		font-size: 16px;
		color: #4b4b4b;
		margin-left: 10px;

	}
	.dateget .el-date-editor .el-range-separator{
		width: 8%;
		line-height: 26px;
		margin-bottom: 0;
	}
	.h-formBorder .dateget .el-form-item__content{
		line-height: 0.15rem;
	}
</style>


